import type { ImportedInvoiceReviewFormValues } from '../types/importedInvoiceReviewFormSchema'
import { getFilledImportedInvoiceReviewLineIndexes } from './getFilledImportedInvoiceReviewLineIndexes'
import type { getImportedInvoiceReviewApprovableSchema } from './getImportedInvoiceReviewApprovableSchema'

/**
 * Runs the approve contract against the review values. Fully empty lines are dropped; when every
 * line is empty, the first one is checked, so "at least one line" points at a field. The form never
 * holds fewer than one line. `lineIndexesToCheck[i]` is the form index of `lines[i]` in the parse.
 */
export const parseImportedInvoiceReviewApprovable = (
  approvableSchema: ReturnType<typeof getImportedInvoiceReviewApprovableSchema>,
  values: ImportedInvoiceReviewFormValues,
) => {
  const filledLineIndexes = getFilledImportedInvoiceReviewLineIndexes(values.lines)
  const lineIndexesToCheck = filledLineIndexes.length ? filledLineIndexes : [0]

  const result = approvableSchema.safeParse({
    ...values,
    lines: lineIndexesToCheck.map((lineIndex) => values.lines[lineIndex]),
  })

  return { lineIndexesToCheck, result }
}
